import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { RestWS } from './services/restService';
import { ICTPartnerData } from '../models/bundle';
import { TranslateService } from '@ngx-translate/core';
import { StylizerProvider } from '../providers/StylizerProvider';
import { CSST } from '../theme/CSST';

@Component({ templateUrl: 'app.html' })
export class MyApp {
	rootPage: any = 'TeaserPage';
	customCss: CSST = new CSST();
	salesOrg: ICTPartnerData;

	constructor(
		platform: Platform,
		statusBar: StatusBar,
		splashScreen: SplashScreen,
		private rest: RestWS,
		private translateService: TranslateService,
		private stylizer: StylizerProvider) {

		platform.ready().then(() => {
			// Okay, so the platform is ready and our plugins are available.
			// Here you can do any higher level native things you might need.
			this.translateService.setDefaultLang('de_DE');
			this.translateService.use('de_DE');
			this.init();
			statusBar.styleDefault();
			splashScreen.hide();
		});
	}

	init() {
		let promises = [];
		promises.push(new Promise((resolve, reject) => {
			this.rest.getSalesOrg().then((salesOrg: ICTPartnerData) => {
				resolve(salesOrg);
			}).catch(err => {
				reject(err);
			});
		}));

		promises.push(new Promise((resolve, reject) => {
			this.rest.getLanguages('de_DE').then((labels: any[]) => {
				resolve(labels);
			}).catch(err => {
				reject(err);
			});
		}));

		Promise.all(promises).then((results) => {
			this.salesOrg = results[0];
			window.document.title = this.salesOrg.company.extendedFieldA ? this.salesOrg.company.extendedFieldA : '';
			let colors = this.salesOrg.company.frontendCustomizing ? this.salesOrg.company.frontendCustomizing : null;
			if (this.salesOrg.company.extendedFieldG && this.salesOrg.company.extendedFieldG !== undefined && this.salesOrg.company.extendedFieldG !== '') {
				this.stylizer.setGTM(this.salesOrg.company.extendedFieldG);
			}
			this.stylizer.createCSS(colors, this.customCss.css);
			this.stylizer.setFavicon(window.document.title, colors.brandPrimaryColor);
			this.translateService.setTranslation('de_DE', results[1]);
			this.translateService.use('de_DE');
			if (this.inIframe()) {
				document.body.classList.add("iFrameInside");
			}
			document.querySelector('#app-loader').className = 'hidden';
			console.log('inIframe', this.inIframe());
		}).catch(() => {
			document.querySelector('#app-loader').className = 'hidden';
		});

	}

	inIframe(): boolean {
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts